import { useMutation } from "@apollo/client/react";
import mixpanel from "mixpanel-browser";
import React from "react";

import EDIT_USER from "../../graphql/mutations/EditUser";
import { alert } from "../common/Alert";
import { DSDropdown } from "../design-system/molecules";

const NOTE_EXPIRY_OPTIONS = [
  { label: "1 day", value: 1 },
  { label: "3 days", value: 3 },
  { label: "1 week", value: 7 },
  { label: "2 weeks", value: 14 },
  { label: "1 month", value: 31 },
];

export default function NoteExpiryTime({ data, refetch }) {
  const [editUser] = useMutation(EDIT_USER);

  const handleChange = (value) => {
    const newValue = Number(value);
    editUser({
      variables: { emailExpiryDays: newValue },
    })
      .then(() => {
        alert("success", "Account updated successfully.");
        mixpanel.track("Updated Account Setting", {
          settingName: "Note Link Expiry Time",
          settingKey: "user.emailExpiryDays",
          settingValue: newValue,
        });
        refetch();
      })
      .catch((err) => alert("error", err.message));
  };

  return (
    <div className={"mx-2 self-center"}>
      <DSDropdown
        options={NOTE_EXPIRY_OPTIONS}
        value={data?.user?.emailExpiryDays || 1}
        onChange={(value) => {
          handleChange(value);
        }}
        dataTestId="note-expiry-time-dropdown"
      />
    </div>
  );
}
